module.exports = __webpack_public_path__ + "static/media/print-solid.ce684a17.png";